export default "__VITE_ASSET__C0WQ2gR1__"